@let actual = moduloService.modulo();
<button class="mod-trigger" [style.--mod-color]="actual.color" [matMenuTriggerFor]="modulosMenu"
  aria-label="Cambiar de módulo">
  <span class="iconify trigger-grid" data-icon="solar:widget-3-line-duotone"></span>
  <span class="trigger-sep"></span>
  <i-tabler class="trigger-icon" [name]="actual.icono"></i-tabler>
  <span class="trigger-name">{{ actual.nombre }}</span>
  <span class="iconify trigger-caret" data-icon="solar:alt-arrow-down-linear"></span>
</button>

<mat-menu #modulosMenu="matMenu" class="mod-menu" xPosition="after">
  <div class="mod-panel">
    <div class="mod-head">
      <span class="mod-head-title">Módulos</span>
      <span class="mod-head-sub">Elige dónde quieres trabajar</span>
    </div>
    <div class="mod-grid">
      @for (m of moduloService.modulos; track m.id; let i = $index) {
      <button type="button" class="mod-card" [class.activo]="m.id === actual.id" [style.--mod-color]="m.color"
        [style.animation-delay.ms]="i * 50" (click)="abrir(m)">
        <span class="mod-icon"><i-tabler [name]="m.icono"></i-tabler></span>
        <span class="mod-body">
          <span class="mod-name">{{ m.nombre }}</span>
          <span class="mod-desc">{{ m.descripcion }}</span>
          <span class="mod-count">{{ moduloService.pantallas(m) }} pantallas</span>
        </span>
        @if (m.id === actual.id) {
        <span class="mod-check iconify" data-icon="solar:check-circle-bold"></span>
        }
      </button>
      }
    </div>
  </div>
</mat-menu>
